const hiylloPink = "#fe02fe";
const hiylloOrange = "#fe8f01";
const hiylloBlue = "#0798f2";
export const HiylloTokyoThemeDark = {
    buttonForeground: "white",
    buttonBackground: "linear-gradient(to right, rgb(254 2 254), rgb(254 143 1))",
    background1: "#101014",
    background2: "#17161B",
    background3: "#201f24",
    midground: "#37363a",
    midground1: "#37363a",
    midground1Highlight: "#3c3b3f",
    midground2: "#4d4c50",
    foreground: "#ffffff",
    foregroundInactive: "#656570",
    surfaceShadow: "rgba(0, 0, 0, 0.25) 0px 0px 20px 0px",
    colorScheme: "dark",
    colorSubtleAccent: hiylloBlue,
    colorWarning: "#ff9800"
};
export const HiylloTokyoThemeLight = {
    buttonForeground: "white",
    buttonBackground: "linear-gradient(to right, rgb(254 2 254), rgb(254 143 1))",
    background1: "red",
    background2: "blue",
    background3: "#ffffff",
    midground: "#e0e0e0",
    midground1: "#e0e0e0",
    midground1Highlight: "#e5e5e5",
    midground2: "#eeeeee",
    foreground: "#121212",
    foregroundInactive: "#656570",
    surfaceShadow: "rgba(0, 0, 0, 0.25) 0px 0px 20px 0px",
    colorScheme: "dark",
    colorSubtleAccent: hiylloBlue,
    colorWarning: "#ff9800"
};
